module.exports = __webpack_public_path__ + "media/bg-video3.8214ff3b.mp4";